import { render } from "./AdminBlog.vue?vue&type=template&id=14948570&scoped=true"
import script from "./AdminBlog.vue?vue&type=script&lang=js"
export * from "./AdminBlog.vue?vue&type=script&lang=js"

import "./AdminBlog.vue?vue&type=style&index=0&id=14948570&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14948570"]])

export default __exports__